// @ts-check
import { Tag } from "antd";
import ManageFormsActions from '~/components/AdminPages/ManageForms/ManageFormsActions';
import { useZeroContext } from '~/components/ZeroContext';
import useOrganizationId from '~/hooks/useOrganizationId';
import { safeProfilePic, updateHistoryState } from '~/other/Helper';
import { Link, useHistory } from "react-router-dom";
import UserAvatar from '~/components/Shared/UserAvatar';
import { EventNames, getIncidentTemplateAnalyticsLink } from '~/components/Incidents/IncidentTemplateDataGrid/IncidentTemplateDataGrid.utils';
import UserPopoverCard from '~/components/Shared/UserPopoverCard';

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function IncidentTemplateActionCell({data: form}) {
    const context = useZeroContext();

    if (!form) {
        return null;
    }

    return (
        <ManageFormsActions
            forDataGrid
            form={form}
            onDelete={() => {
                context.events.emit(EventNames.REFRESH_DATA);
            }}
            refresh={() => {
                context.events.emit(EventNames.REFRESH_DATA);
            }}
        />
    );
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function IncidentTemplateNameCell({data: form, value: name, api}) {
    const history = useHistory();
    const orgId = useOrganizationId();

    if (!form) {
        return null;
    }

    const linkUrl = getIncidentTemplateAnalyticsLink(form, orgId);

    const onClick = () => {
        updateHistoryState(history, {gridState: api.getState()});
    }

    return (
        <div className="flex gap-sm" style={{ alignItems: "center" }}>
            <Link to={linkUrl} className="blue-link" onClick={onClick}>
                {name}
            </Link>
            {form.is_public && (
                <Tag color="green" style={{ borderColor: "#52c41a", fontSize: "11px" }}>
                    Public
                </Tag>
            )}
        </div>
    );
}
